<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <v-container>
        <v-row class="align-center justify-center'">
          <v-col cols="12" md="7">
            <slot name="main-content"></slot>
          </v-col>
          <v-col
            cols="12"
            md="5"
            class="d-flex flex-column"
            :class="$vuetify.display.mdAndUp ? 'align-end' : 'align-center'"
          >
            <OnexButton
              width="320"
              color="primary"
              @click="callToActionCallback"
              :aria-label="callToActionButtonText"
            >
              {{ callToActionButtonText }}
            </OnexButton>
            <div
              class="text-center call-to-action-width"
              :class="$vuetify.display.mdAndUp ? 'px-0' : 'px-4'"
            >
              <slot name="call-to-action"></slot>
            </div>
          </v-col>
        </v-row>
        <slot name="bottom-content"></slot>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  emits: ['callToActionButtonClicked'],
  components: {
    OnexButton,
  },
  props: {
    callToActionButtonText: {
      type: String,
      required: false,
    },
  },
  methods: {
    callToActionCallback() {
      this.$emit('callToActionCallback');
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.call-to-action-width {
  width: 320px;
}
</style>
